// extracted by mini-css-extract-plugin
module.exports = {"facebookButton":"facebook-login-button_facebookButton__qOtQK"};